import React, { useState } from 'react'
import classNames from 'classnames'

import style from './style.module.css'

export { default as ImageGalleryImage } from './Image'
export { default as ImageGalleryThumbnail } from './Thumbnail'

type RenderProp = ({
  activeIndex,
  setActiveIndex,
}: {
  activeIndex: number
  setActiveIndex: (index: number) => void
}) => React.ReactNode

type Props = React.ComponentPropsWithoutRef<'div'> & {
  children: RenderProp | React.ReactNode
}

function ImageGallery({ className, children, ...props }: Props) {
  const [activeIndex, setActiveIndex] = useState(0)
  return (
    <div className={classNames(style.wrapper, className)} {...props}>
      {typeof children === 'function'
        ? children({ activeIndex, setActiveIndex })
        : children}
    </div>
  )
}

export default ImageGallery
